import {
  BookSelectorValue,
  BooksSelector,
} from 'components/forms/book-selector';
import {
  CategoriesSelector,
  CategorySelectorValue,
} from 'components/forms/category-selector';
import {
  FestivalSelector,
  FestivalSelectorValue,
} from 'components/forms/festival-selector';
import { StandardInput } from 'components/forms/input';
import { TextEditor } from 'components/text-editor/text-editor';
import { EditorState } from 'draft-js';
import { UseInputReturn } from 'lib/hooks/use-input';
import { useEffect } from 'react';
import DatePicker from 'react-datepicker';

interface Props {
  title: UseInputReturn<string>;
  image: UseInputReturn<string>;
  startDate: UseInputReturn<Date>;
  endDate: UseInputReturn<Date>;
  books: UseInputReturn<BookSelectorValue[]>;
  seats: UseInputReturn<number>;
  freeSeats: UseInputReturn<number>;
  price: UseInputReturn<number>;
  categories: UseInputReturn<CategorySelectorValue[]>;
  description: UseInputReturn<EditorState>;
  videoUrl: UseInputReturn<string>;
  partOfFestival: UseInputReturn<FestivalSelectorValue[]>;
  speakers: UseInputReturn<string>;
  location: UseInputReturn<string>;
  videoConfLocation: UseInputReturn<string>;
  setCanSave?: (bool: boolean) => void;
}

export const StandardEventForm = ({
  title,
  description,
  startDate,
  endDate,
  image,
  books,
  categories,
  seats,
  freeSeats,
  location,
  speakers,
  partOfFestival,
  price,
  setCanSave,
  videoUrl,
  videoConfLocation,
}: Props) => {
  useEffect(() => {
    if (!!setCanSave) setCanSave(false);
  }, []);

  useEffect(() => {
    if (
      speakers.isModified &&
      price.isModified &&
      seats.isModified &&
      location.isModified &&
      !!setCanSave
    ) {
      setCanSave(true);
    }
  }, [speakers.value, price.value, seats.value, location.value]);

  return (
    <fieldset className='flex flex-row flex-wrap w-full col-span-full space-y-4 lg:space-y-0 lg:grid lg:grid-cols-2 xl:grid-cols-3 lg:gap-4 xl:gap-8'>
      <StandardInput
        id='title'
        name='title'
        label='Title'
        type='text'
        bind={{ ...title.bind }}
      />
      <StandardInput
        id='image'
        name='image'
        label='Image'
        type='text'
        bind={{ ...image.bind }}
      />
      <label htmlFor='startDate' className='w-full flex flex-col z-10'>
        Start Date
        <DatePicker
          className='w-full '
          selected={startDate.value}
          onChange={(date) => startDate.setValue(date)}
          showTimeSelect
          timeFormat='HH:mm'
          timeIntervals={15}
          timeCaption='time'
          dateFormat='dd/MM/yy - h:mm aa'
        />
      </label>
      <label htmlFor='endDate' className='w-full flex flex-col'>
        End Date
        <DatePicker
          className='w-full'
          selected={endDate.value}
          onChange={(date) => endDate.setValue(date)}
          showTimeSelect
          timeFormat='HH:mm'
          timeIntervals={15}
          timeCaption='time'
          dateFormat='dd/MM/yy - h:mm aa'
        />
      </label>
      <BooksSelector
        className='w-full'
        label={`Books (${books.value.length})`}
        value={books.value}
        setValue={books.setValue}
      />
      <label htmlFor='speakers' className='w-full flex flex-col'>
        Speakers
        <input type='text' name='speakers' id='speakers' {...speakers.bind} />
      </label>
      <StandardInput
        id='videoUrl'
        name='videoUrl'
        label='Video URL'
        type='text'
        bind={{ ...videoUrl.bind }}
      />
      <FestivalSelector
        className='w-full'
        label='Part of Festival'
        value={partOfFestival.value}
        setValue={partOfFestival.setValue}
      />{' '}
      <StandardInput
        label='Voucher Price'
        type='number'
        name='price'
        id='price'
        bind={{ ...price.bind }}
      />
      <StandardInput
        label='Location'
        type='text'
        name='location'
        id='location'
        bind={{ ...location.bind }}
      />
      <StandardInput
        label='Link To Online Meeting'
        id='videoConfLocation'
        name='videoConfLocation'
        type='text'
        bind={{ ...videoConfLocation.bind }}
      />
      <StandardInput
        id='seats'
        name='seats'
        type='number'
        label='Total Seats'
        bind={{ ...seats.bind }}
      />
      <StandardInput
        id='freeSeats'
        name='freeSeats'
        type='number'
        label='Free Seats'
        bind={{ ...freeSeats.bind }}
      />
      <CategoriesSelector
        className='w-full'
        label='Categories'
        value={categories.value}
        setValue={categories.setValue}
      />
      <label htmlFor='description' className='w-full col-span-full'>
        Description
        <TextEditor state={description.value} setState={description.setValue} />
      </label>
    </fieldset>
  );
};
